export class VerticalProgressBarController {
    public nodes: { step: number, label: string, active: boolean, complete: boolean }[];
    public currentStep: number;
    
    constructor(private $rootScope, private $element) {}
}
